import React, {useRef, useState} from "react"
import { useOnClickOutside } from 'usehooks-ts'
import classes from "./LineMenu.module.scss"

interface IMenuItem {
  id: number
  text: string
  type?: string
  onClick: () => void
}

interface ILineMenuProps {
  items: IMenuItem[]
  disabled?: boolean
}

export default function LineMenu({items, disabled}: ILineMenuProps) {

  const [menuShown, toggleMenu] = useState(false)
  const wrapClasses = [classes.wrap]

  if (disabled) {
    wrapClasses.push(classes.disabled)
  }

  const menuList = items.map(({id, text,type,onClick}) => {

    const itemCls = [classes.item, classes.itemTypeCls]

    if (type) {
      itemCls.push(classes[`item_${type}`])
    }

    const clickHandler = () => {
      toggleMenu(false)
      onClick()
    }

    return (
      <div
        key={id}
        className={itemCls.join(" ")}
        onClick={clickHandler}
        role={"menuitem"}
        tabIndex={-1}
      >
        {text}
      </div>
    )
  })

  const menuRef = useRef(null)

  const handleClickOutside = () => {
    toggleMenu(false)
  }

  const toggleClickHandler = () => {
    if (!disabled) toggleMenu(!menuShown)
  }

  useOnClickOutside(menuRef, handleClickOutside)

  return (
    <div className={wrapClasses.join(" ")}
     ref={menuRef}
    >
      <div
        className={classes.toggle}
        onClick={() => {
          toggleClickHandler()
        }}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
      {menuShown &&
        <div className={classes.list}>
          {menuList}
        </div>
      }
    </div>
  )
}